import { useMutation } from '@apollo/client';
import { AclAction, FileSystemProjectNodesRelationType } from 'shared/domains/apollo/generated/types';
import { AddProjectNodesDocument } from './mutation.gql';
export const useAddDocumentsToProject = () => {
    const [mutate, state] = useMutation(AddProjectNodesDocument);
    const addDocumentsToProject = (projectId, documents) => {
        const defaultRelationType = FileSystemProjectNodesRelationType.Regular;
        const defaultAclActions = [AclAction.Read];
        const nodes = documents.map(({ documentId, aclActions }) => ({
            documentId,
            relationType: defaultRelationType,
            aclActions: aclActions || defaultAclActions,
        }));
        return mutate({
            variables: { projectId, nodes },
            update: (cache, { data }) => {
                const { createFileSystemProjectNodes = [] } = data || {};
                if (createFileSystemProjectNodes.length > 0) {
                    cache.modify({
                        id: cache.identify({ id: projectId, __typename: 'FileSystemProject' }),
                        fields: {
                            nodes(existing = [], { toReference }) {
                                const newReferences = createFileSystemProjectNodes.map((node) => toReference(node, true));
                                return [...existing, ...newReferences];
                            },
                            nodesCount(existing = 0) {
                                return existing + createFileSystemProjectNodes.length;
                            },
                        },
                    });
                }
            },
        });
    };
    return [addDocumentsToProject, state];
};
